const pathBase = `/candidates/disapprove/`;

export const disapprove = {
  post: () => pathBase,
};
